window.addEventListener('load', function () {
    if (document.querySelectorAll('.imageText').length) {
        gsap.registerPlugin(ScrollTrigger);

        const elements = document.querySelectorAll('.imageText');

        elements.forEach(element => {
            let image = element.querySelector('.image');
            let decoration = element.querySelector('.decoration');
            let img = element.querySelector('img');
            let start = -100;

            if (element.classList.contains('imageRight')) {
                start = 100;
            }

            let tl = gsap
                .timeline({
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 50%',
                        end: 'bottom 50%',
                        toggleActions: 'play none none none',
                    },
                })
                .set(image, { autoAlpha: 1 })
                .from(image, { duration: 1.5, xPercent: -100, ease: Power2.out })
                .from(img, { duration: 1.5, xPercent: 100, scale: 1.5, delay: -1.5, ease: Power2.out })
                .from(decoration, { autoAlpha: 0, duration: 1.5, xPercent: start }, '-=.7');

            /* parallax scroll */
            gsap.from(decoration, {
                yPercent: -50,
                ease: 'none',
                scrollTrigger: {
                    trigger: element,
                    start: 'top 50%',
                    end: 'bottom 50%',
                    scrub: true,
                },
            });
        });
    }
});
